// Mapbox Configuration
// Set VITE_MAPBOX_TOKEN in your .env file (starts with 'pk.')
// Get your token at: https://account.mapbox.com/access-tokens/

export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN || '';

// Default map center (Germany)
export const DEFAULT_MAP_CENTER: [number, number] = [10.4515, 51.1657];
export const DEFAULT_MAP_ZOOM = 6;
